import type React from 'react'
import infoSvg from '../../assets/figma/118-4028/ec4f3e2f76c3b4488631774a4c48ae72036ea8df.svg'

export interface InfoCardProps {
  title?: string
  description?: string
  className?: string
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title = 'ウォレットアドレスを連携',
  description = 'カスタマーデスクまでウォレットアドレスを連携してください。準備が完了すると、ウォレットをご利用いただけます。',
  className,
}) => {
  return (
    <div
      className={`bg-orange-50 flex flex-col items-center justify-center gap-6 px-4 py-8 rounded-[16px] ${className ?? ''}`}
    >
      <div className="flex w-[311px] max-w-full flex-col items-center justify-center gap-4">
        <div className="relative size-10 overflow-clip">
          <img
            src={infoSvg}
            alt=""
            aria-hidden="true"
            className="absolute inset-[1.32%] block size-full max-w-none"
          />
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-1 leading-none">
          <div className="text-zinc-900 text-[16px] font-semibold">
            <p className="m-0 leading-[1.3]">{title}</p>
          </div>
          <div className="text-center text-zinc-500 text-[14px] font-medium tracking-[-0.28px]">
            <p className="m-0 leading-[20px]">{description}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InfoCard
